<template>
  <div class="dialog" ref="dialog">
    <div class="close-container">
      <div class="close" v-on:click="hide">
        <svg width="24" height="24" viewBox="0 0 24 24">
          <path fill="none" d="M0 0h24v24H0V0z" />
          <path 
            d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"
          />
        </svg>
      </div>
    </div>
    <generate-link :data="data" />
  </div>
</template>

<script>
  import GenerateLink from '@/components/generate-link';

  export default {
    components: {
      'generate-link': GenerateLink,
    },
    props: {
      data: [Object]  
    },
    methods: {
      show: function() {
        this.$refs.dialog.setAttribute('active', '');
      },
      hide: function() {
        this.$refs.dialog.removeAttribute('active');
        this.$emit('onClose');
      },
    },
  }
</script>

<style lang="scss" scoped>
  .dialog {
    position: absolute;
    background: #fff;
    max-width: 740px;
    width: 100%;
    left: 0;
    right: 0;
    top: 64px;
    margin: auto;
    z-index: 3;
    box-shadow: 0 5px 30px 0 rgba(0, 0, 0, 0.15);
    border-radius: 5px;
    padding: 16px 24px;
    opacity: 0;
    pointer-events: none;
    transform: scale(.5);
    transition: 150ms transform ease, 200ms opacity ease;

    &[active] {
      opacity: 1;
      transform: scale(1);
      pointer-events: visible;
    }

    .close-container {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 12px;

      .close {
        border-radius: 50%;
        height: 36px;
        width: 36px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        transition: 150ms background-color ease;

        &:hover {
          background: #f0f0f0;
        }
      }
    }
  }

  @media screen and (max-width: 720px) {
    .dialog {
      display: none;
    }
  }
</style>